import { X } from "lucide-react";
import { Button } from "./button";

interface DeleteConfirmationAlertProps {
  isOpen: boolean;
  itemName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmationAlert({
  isOpen,
  itemName,
  onCancel,
  onConfirm
}: DeleteConfirmationAlertProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-all duration-200" style={{zIndex:100000}}>
      <div className="bg-white animate-in fade-in-0 zoom-in-90 duration-150 bg-clarofrente-01 rounded-xl shadow-lg p-6 max-w-md w-full mx-4 relative">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-inter-20-semi-bold text-clarotexto-201">
            Confirmar Exclusão
          </h3>
          <Button
            variant="ghost"
            size="icon"
            onClick={onCancel}
            className="h-8 w-8 rounded-full absolute top-3 right-3"
          >
            <X className="size-4" />
          </Button>
        </div>
        
        <div className="mb-6">
          <p className="text-clarotextos-02 mb-2">
            Tem certeza que deseja excluir o produto <span className="font-semibold text-clarotexto-201">{itemName}</span>?
          </p>
          <p className="text-clarotextos-03 text-sm">
            Esta ação não poderá ser desfeita e todos os dados relacionados serão removidos permanentemente.
          </p>
        </div>
        
        <div className="flex gap-3 justify-end">
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-clarotextos-03 text-clarotextos-02"
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            className="bg-red-600"
          >
            Excluir
          </Button>
        </div>
      </div>
    </div>
  );
} 